import React from 'react';
import styled from 'styled-components';
import icon from '@images/svg/path-doublearrow.svg';
import i18next from 'i18next';
import { Mixins } from 'planoplan-ui-kit/core/mixins';
import { Colors } from 'planoplan-ui-kit/core/colors';

export const ToggleSidebar = ({ open, ...restProps }) => (
  <Button {...restProps} open={open}>
    <Icon open={open}>
      <img src={icon} alt="toggle" />
    </Icon>
    <Text>{i18next.t('cabinet.close')}</Text>
  </Button>
);

const Button = styled.button`
  ${Mixins.transition('width', '0.1s')};
  width: ${(p) => (p.open ? '120px' : '24px')};
  height: 24px;
  background: transparent;
  border: none;
  cursor: pointer;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  color: ${Colors.light_gray};
  overflow: hidden;
`;

const Icon = styled.div`
  width: 24px;
  height: 24px;
  background: transparent;
  line-height: 0;
  font-size: 0;
  border: none;
  cursor: pointer;
  margin: 0;
  padding: 0;
  transform: rotate(${(p) => (p.open ? '-180deg' : '0')});
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;

const Text = styled.div`
  margin-left: 15px;
  flex-grow: 1;
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
`;
